import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { scrollToSection } from "./scrollTo";

const LINKS = [
  { label: "Product", href: "#product" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Pricing", href: "#pricing" },
];

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -90, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
      className="fixed inset-x-0 top-0 z-50"
      data-testid="main-nav"
    >
      <div className="mx-auto max-w-7xl px-4 pt-4 sm:px-6">
        <nav className="flex items-center justify-between rounded-full border border-white/10 bg-[#050505]/70 px-5 py-3 backdrop-blur-xl">
          <button
            onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
            className="flex items-center gap-2.5"
            data-testid="nav-logo"
          >
            <span className="block h-3.5 w-3.5 rotate-45 rounded-[3px] bg-[#00FF66] shadow-[0_0_18px_rgba(0,255,102,0.8)]" />
            <span className="font-display text-lg font-extrabold tracking-[0.28em] text-white">
              VEKTOR
            </span>
          </button>

          <div className="hidden items-center gap-8 md:flex">
            {LINKS.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollToSection(link.href)}
                className="text-sm font-medium text-white/60 transition-colors duration-200 hover:text-[#00FF66]"
                data-testid={`nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </button>
            ))}
            <Link
              to="/about"
              className="text-sm font-medium text-white/60 transition-colors duration-200 hover:text-[#00FF66]"
              data-testid="nav-link-about"
            >
              About
            </Link>
            <Link
              to="/changelog"
              className="text-sm font-medium text-white/60 transition-colors duration-200 hover:text-[#00FF66]"
              data-testid="nav-link-changelog"
            >
              Changelog
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <a
              href="/login"
              className="rounded-full border border-white/15 px-3.5 py-2 text-xs font-semibold text-white/70 transition-colors duration-200 hover:border-[#00FF66]/50 hover:text-[#00FF66] sm:px-5 sm:text-sm"
              data-testid="nav-signin-link"
            >
              Sign in
            </a>
            <motion.a
              href="/signup"
              whileHover={{ scale: 1.06 }}
              whileTap={{ scale: 0.96 }}
              className="rounded-full bg-[#00FF66] px-3.5 py-2 text-xs font-bold text-black shadow-[0_0_24px_rgba(0,255,102,0.35)] sm:px-5 sm:text-sm"
              data-testid="nav-start-trial-button"
            >
              <span className="sm:hidden">Try free</span>
              <span className="hidden sm:inline">Start free trial</span>
            </motion.a>
          </div>
        </nav>
      </div>
    </motion.header>
  );
}
